import React, { ComponentType } from 'react'
import { ButtonProps } from 'src/ui/basic/api/Button'
import { Button } from 'src/ui/basic/Button'
import { Link } from 'react-router-dom'
import { css } from 'src/ui/style/css'

export type CtaButtonProps = Omit<
    ButtonProps,
    'color' | 'uppercase' | 'outline'
> & {
    id?: string
    emphasize?: boolean
    big?: boolean
    alwaysEnabled?: boolean
}

export const CtaButton: ComponentType<CtaButtonProps> = ({
    children,
    id,
    emphasize = true,
    big = false,
    alwaysEnabled = false,
    ...rest
}) => (
    <Button
        {...rest}
        id={id}
        alwaysEnabled={alwaysEnabled}
        color="secondary"
        uppercase
        outline={!emphasize}
        css={
            big &&
            css`
                padding: 1em 2em;
            `
        }
    >
        {children}
    </Button>
)

export type CtaButtonLinkProps = Omit<CtaButtonProps, 'onClick'> & {
    to: string
    onClick?: () => void
}

export const CtaButtonLink: ComponentType<CtaButtonLinkProps> = ({
    children,
    onClick,
    to,
    ...rest
}) => (
    <Link to={to}>
        <CtaButton {...rest} onClick={() => onClick && onClick()}>
            {children}
        </CtaButton>
    </Link>
)
